module.exports = __webpack_public_path__ + "static/media/wordpress.65289017.svg";